import { APITypes } from "@stellar/api-logic";
import {
  RequiredFeatureCompanyLevelName,
  RequiredFeaturesCompanyLevel,
} from "@utils/feature-control/company/company-feature-control-types";

/**
 * Object that determines all different feature permission for users to get
 * access on the company level.
 */
export const requiredFeaturesCompanyLevel: RequiredFeaturesCompanyLevel<RequiredFeatureCompanyLevelName> =
  {
    /** Whether the user can see groups of the company. */
    [RequiredFeatureCompanyLevelName.canViewCompanyGroups]: {
      companySubscriptionRoles: [
        APITypes.EUserSubscriptionRole.dashboardGroups,
      ],
    },

    /** Whether the user can see projects of the company related to the user. */
    [RequiredFeatureCompanyLevelName.canViewProjects]: {
      companySubscriptionRoles: [
        APITypes.EUserSubscriptionRole.dashboardProjects,
      ],
    },

    /** Whether the user has permission to see the company members list. */
    [RequiredFeatureCompanyLevelName.canViewCompanyMembers]: {
      companySubscriptionRoles: [
        APITypes.EUserSubscriptionRole.dashboardUserDirectory,
      ],
    },

    /** Whether the user has permission to see the company analytics page. */
    [RequiredFeatureCompanyLevelName.canViewAnalytics]: {
      companySubscriptionRoles: [
        APITypes.EUserSubscriptionRole.dashboardInsights,
      ],
    },

    /** Whether the user has permission to see the company premium analytics page. */
    [RequiredFeatureCompanyLevelName.canViewPremiumAnalytics]: {
      companySubscriptionRoles: [
        APITypes.EUserSubscriptionRole.companyInsights,
      ],
    },

    /** Whether the user has permission to see the company integrations page. */
    [RequiredFeatureCompanyLevelName.canViewIntegrations]: {
      companySubscriptionRoles: [
        APITypes.EUserSubscriptionRole.dashboardIntegrations,
      ],
    },

    /** Whether the user has permission to see the company settings page. */
    [RequiredFeatureCompanyLevelName.canViewWorkspaceSettings]: {
      companySubscriptionRoles: [
        APITypes.EUserSubscriptionRole.dashboardSettings,
      ],
    },
  };
